import React from 'react';

import { StandardError } from 'types/error';
import closeUser from '_assets/images/close-user.svg';
import warningIcon from '_assets/images/warning-inactive.svg';
import { UnexpectedError } from 'components/error-message/UnexpectedError';
import { ErrorMessageForm } from 'components/forms/error-message-form/ErrorMessageForm';

type Props = {
  error: StandardError;
};

export const SignupError: React.FC<Props> = ({ error }) => {
  if (error.responseCode === 429) {
    return (
      <ErrorMessageForm
        imgSrc={warningIcon}
        titleCaption="You've reached your signup limit"
        titleContent="Try again tomorrow!"
        contactSupportButton
        backToLogin
      />
    );
  }

  if (error.responseCode === 403) {
    return (
      <ErrorMessageForm
        imgSrc={closeUser}
        titleCaption="Traffic blocked"
        titleContent="You cannot create an account"
        backToLogin
      />
    );
  }

  return <UnexpectedError requestId={error.requestId} description={error.description} />;
};
